import React from 'react';
import { connect } from 'react-redux';

import { getAirportCitiesForFilter } from '../../../store/flights-filters';

import MultichoiceFilterGroup from '../../../../../../../components/Filters/components/MultichoiceFilterGroup';
import type { DepartureAirportFilterProps, ExtendedFilterInfo } from '../types';

import { getAirportsName } from '../utils';

const FilterDepartureAirport: any = (props: DepartureAirportFilterProps) => {
  const { isMobile, airportCity, data } = props;

  const airportNameByCount = getAirportsName(data.length);

  FilterDepartureAirport.filterLabel = `${airportNameByCount} ${airportCity}`;

  return (
    <MultichoiceFilterGroup
      {...props}
      isCollapsible={!isMobile}
      Filter={FilterDepartureAirport}
    />
  );
};

FilterDepartureAirport.getFilterVisibleName = (
  filterOptionData: ExtendedFilterInfo,
) => filterOptionData.name;

FilterDepartureAirport.filterName = 'departure_airports';

const mapPropsToState = (state) => ({
  airportCity: getAirportCitiesForFilter(
    state,
    FilterDepartureAirport.filterName,
  ),
});

export default connect(mapPropsToState)(FilterDepartureAirport);
